var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('principal'),_c('steps'),_c('why-with-us'),_c('frequent-questions')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }